import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/styled-system'
import { asChakraVariable } from '~/themes/colors/colors'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'

import { getName } from '@mangovoice/core'

import { sharedComponentColorKeys } from './_colors'

const Colors = sharedComponentColorKeys.CustomTooltip

const CustomTooltipParts = ['container'] as const

const helpers = createMultiStyleConfigHelpers(CustomTooltipParts)
export const CustomTooltipStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      backgroundColor: Colors.Background,
      borderRadius: '0.375rem',
      padding: '1rem',
      border: '1px solid',
      borderColor: Colors.Border,
      boxShadow: `${asChakraVariable(Colors.BoxShadow)} 0px 4px 12px 0px`,
    },
  },
})

export const useCustomTooltipStyles = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof CustomTooltipParts>(
    getName({ CustomTooltipStyle }),
    props,
  )
}
